import React from "react"
// import Link from "next/link"
import { Link, useNavigate } from "react-router-dom"

// import Layout from "../components/Layout"
// import sanity from "../lib/sanity"
import sanityClient from "@sanity/client"

// import listStyles from "../styles/list";
import imageUrlFor from "../utils/ImageUrlFor"
import { urlFor } from "../client"

// const query = `*[_type == "movie"] {
//   _id,
//   title,
//   releaseDate,
//   poster,
//   "posterAspect": poster.asset->.metadata.dimensions.aspectRatio,
//   "director": crewMembers[job == "Director"][0].person->name
// }[0...50]
// `

const Movies = ({ movie: { title, poster, _id, releaseDate, director, posterAspect } }) => {
  return (
    <div className=" relative cursor-zoom-in w-auto hover:shadow-lg rounded-lg overflow-hidden transition-all duration-500 ease-in-out">
      {title}
      {
        <img
          src={urlFor(poster).ignoreImageParams().width(200)}
          className="rounded-lg "
          height={100 / posterAspect}
        />
      }

      <li key={_id} className="list__item">
        <Link to={`/movies/${_id}`}>
          <a>
            <div style={{ paddingTop: "0.2em" }}>{releaseDate.substr(0, 4)}</div>
            <h3>{title}</h3>
            {director && <span className="movies-list__directed-by">Directed by {director}</span>}
          </a>
        </Link>
      </li>
    </div>
  )
}

// export const getStaticProps = async () => {
//   const movies = await sanityClient.fetch(query)
//   return {
//     props: { movies }, // will be passed to the page component as props
//   }
// }

export default Movies

// import React, { useState } from "react"
// import { Link, useNavigate } from "react-router-dom"
// import { v4 as uuidv4 } from "uuid"
// import { MdDownloadForOffline } from "react-icons/md"
// import { AiTwotoneDelete } from "react-icons/ai"
// import { BsFillArrowUpRightCircleFill } from "react-icons/bs"
// import { urlFor, client } from "../client"
// import { fetchUser } from "../utils/fetchUser"

// const Pin = ({ movies, posterAspect, releaseDate, title, _id, director, poster }) => {
//   const [postHovered, setPostHovered] = useState(false)
//   const navigate = useNavigate()
//   console.log(title)
//   const user = fetchUser()

//   return (
//     <div className="m-2">
//       <div
//         onMouseEnter={() => setPostHovered(true)}
//         onMouseLeave={() => setPostHovered(false)}
//         className=" relative cursor-zoom-in w-auto hover:shadow-lg rounded-lg overflow-hidden transition-all duration-500 ease-in-out"
//       >
//         {movies.map((movie) => (
//           <li key={movie._id} className="list__item">
//             <Link href={`/movies/${movie._id}`}>
//               <a>
//                 {movie.poster}
//                 <div style={{ paddingTop: "0.2em" }}>{movie.releaseDate.substr(0, 4)}</div>
//                 <h3>{movie.title}</h3>
//                 {movie.director && (
//                   <span className="movies-list__directed-by">Directed by {movie.director}</span>
//                 )}
//               </a>
//             </Link>
//           </li>
//         ))}
//       </div>
//     </div>
//   )
// }

// export default Pin
